/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputEwActiveFrequency } from './OutputEwActiveFrequency';
import {
    OutputEwActiveFrequencyFromJSON,
    OutputEwActiveFrequencyFromJSONTyped,
    OutputEwActiveFrequencyToJSON,
} from './OutputEwActiveFrequency';

/**
 * 
 * @export
 * @interface OutputEwZoneData
 */
export interface OutputEwZoneData {
    /**
     * 
     * @type {Array<OutputEwActiveFrequency>}
     * @memberof OutputEwZoneData
     */
    frequencies: Array<OutputEwActiveFrequency>;
    /**
     * 
     * @type {number}
     * @memberof OutputEwZoneData
     */
    zoneId: number;
    /**
     * 
     * @type {string}
     * @memberof OutputEwZoneData
     */
    zoneName: string;
}

/**
 * Check if a given object implements the OutputEwZoneData interface.
 */
export function instanceOfOutputEwZoneData(value: object): boolean {
    if (!('frequencies' in value)) return false;
    if (!('zoneId' in value)) return false;
    if (!('zoneName' in value)) return false;
    return true;
}

export function OutputEwZoneDataFromJSON(json: any): OutputEwZoneData {
    return OutputEwZoneDataFromJSONTyped(json, false);
}

export function OutputEwZoneDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputEwZoneData {
    if (json == null) {
        return json;
    }
    return {
        
        'frequencies': ((json['frequencies'] as Array<any>).map(OutputEwActiveFrequencyFromJSON)),
        'zoneId': json['zoneId'],
        'zoneName': json['zoneName'],
    };
}

export function OutputEwZoneDataToJSON(value?: OutputEwZoneData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'frequencies': ((value['frequencies'] as Array<any>).map(OutputEwActiveFrequencyToJSON)),
        'zoneId': value['zoneId'],
        'zoneName': value['zoneName'],
    };
}

